import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import { comma,instance } from './common';
import trash_img from './img/trash.png';
import check_on from './img/check_on.png';
import { formatDate,phoneFormat,currentDate,currentNoHyDate } from './common';
import Bottom_menu from './Bottom_menu';
import DaumPostcode from 'react-daum-postcode';
import close from './img/bi_x.png'

function totalPrice(data) {
  let price = 0;
  data.forEach(function (v) {
    if(v.is_check == 1){
      price += Number(v.daeri_price) * v.pr_count;
    }
  });
  return comma(price);
}

function nameMake(data){
  let name = '';
  let cnt = 0;
  data.forEach(function (v) {
    if(v.is_check == 1){
      if(cnt == 0){
        name = v.pr_name;
      }
      cnt++;
      
    }
  });

  if(cnt > 1){
    let nowCount = cnt-1;
    name = name + ' 외 ' + (nowCount) + '개';
  }

  return name;
}


const postCodeStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    border: "1px solid #000000",
    maxWidth: "700px",
    maxHeight: "500px"
};

const postClose = {
  borderBottom:'1px solid black',
  height:'30px',
  textAlign:'right',
  padding:'4px 7px',
  background:'#F3F3F3'
}

const closeImage = {
  fontSize:'19px',
  lineHeight:'19px'
}

const Postcode = ({myData,setMyData,isPost,setIsPost}) => {
  
  const handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = ''; 
    
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }

    console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'

    setMyData([{...myData[0],si_address:fullAddress}])

    setIsPost(!isPost);
    
  }


  const closePost = () => {
    setIsPost(!isPost);
  }

  return (
    <div style={postCodeStyle}>
      <div style={postClose}>
        <span style={closeImage} onClick={closePost}>X</span>
      </div>
      <DaumPostcode
        onComplete={handleComplete}
        autoClose
      />
    </div>
  );
}

function purchaseNumber(cnt){
   let num = 'OR'+currentNoHyDate()+'-';

   if(cnt < 10){
      num += '00'+cnt;
   }else if(cnt >= 10 && cnt < 100){
      num += '0'+cnt;
   }else{
      num += String(cnt);
   }

   return num;
}

function OrderSheet({ history, location, match }) {

  let session = JSON.parse(window.sessionStorage.result);
  let { u_type, u_id, u_sigong,u_login_id } = session;
  const query = queryString.parse(location.search);

  const [data, setData] = useState([]);
  const [myData, setMyData] = useState([]);
  const [purchaseCnt, setCnt] = useState([]);


  let obj = {
    u_id: u_id,
  }

  useEffect(() => {

    const fetchData = async () => {
      instance.post('/p_cart/id', obj).then(function (res) {setData(res.data.rows);});
      instance.post('/sigong/id', {si_id:u_sigong}).then(function (res) {setMyData(res.data);});
      instance.post('/purchase/count',{current:currentNoHyDate()}).then(function (res) {setCnt(res.data[0].cnt+1);});

    };

    fetchData();

  }, []);


  const wordBreak = {
    wordBreak: 'keep-all'
  }
  const w60 = {
    width: '60%',
    verticalAlign: 'top'
  }
  const w30 = {
    width: '40%'
  }

  const moreCss = {
    width: '35px'
  }


  const bgSet = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '25%',
    height: '80px',
    borderRadius: '5px',
    display: 'inline-block',
  }

  const ab = {
    position: 'absolute',
    right: '-4px',
    top: '14px',
    color: 'lightgray',
    fontSize: '10px'
  }
  const traswi = {
    width: '25px'
  }


  const deleteCart = (e) => {
    const { id } = e.target.dataset;

    setData(data.filter(v => v.p_cart_id != id));

    let obj = { p_cart_id: id };

    const fetchData = async () => {
      instance.post('/p_cart/delete', obj).then(function (res) {
        alert('해당 상품이 삭제되었습니다.');

      });

    };

    fetchData();


  }

  const checkedData = (e) => {
    const {cart_id,is_check} = e.target.dataset;
    let reversed;
    if(is_check == 1){
      reversed = 0;
    }else if(is_check == 0){
      reversed = 1;
    }
    setData(data.map(v => v.p_cart_id == cart_id ? {...v,is_check:reversed} : v))
    let obj = {
      is_check:reversed
    }
    let UpdateObj = {
      obj:obj,
      whereField:'p_cart_id',
      whereValue:cart_id
    }
    const fetchData = async () => {

      instance.post('/p_cart/update', UpdateObj).then(function (res) {
        
        
      });

    };

    fetchData();
  }
  

  const allChecked = () => {
    setData(data.map(v => ({...v,is_check:1}) ))
    let obj = {
      is_check:1
    }
    let UpdateObj = {
      obj:obj,
      whereField:'u_id',
      whereValue:u_id
    }
    const fetchData = async () => {

      instance.post('/p_cart/update', UpdateObj).then(function (res) {
        
        
      });

    };

    fetchData();
  }

  const allDelete = () => {
    setData(data.filter(v => v.u_id != u_id));
  
      let obj = { u_id: u_id };
  
      const fetchData = async () => {
        instance.post('/p_cart/all-delete', obj).then(function (res) {
          alert('전체 삭제 되었습니다.');
  
        });
  
      };
  
      fetchData();
  }

  console.log('product cart data : ', data)


  const inputStyle = {
      border:0,
      padding:0,
      borderBottom:'1px solid #ddd'
  }

  const abSpan = {
      position:'absolute',
      right:'0'
  }

  
  const [isPost, setIsPost] = useState(false);

  console.log('myData : ', myData)

  const goPay = () => {
    if(data.length !== 0){
        let str = '';
        let price = '';
        let name = nameMake(data);
        let o_id = purchaseNumber(purchaseCnt);
        price = totalPrice(data);

        const fetchData = async () => {

          let obj = {
            p_u_id:u_id,
            p_pr_id:JSON.stringify(data.filter(v=> v.is_check === 1)),
            p_number:o_id,
            or_sigong:myData[0].si_name,
            or_phone:myData[0].si_tel,
            or_address:myData[0].si_address,
            or_detail:myData[0].or_detail,
            or_date:currentDate()
          }
          

          instance.post('/purchase/insert', {obj:obj}).then(function (res) {    
            instance.post('/p_cart/chk-delete', {u_id:u_id}).then(function (res) {
                window.location.replace('https://abys-service.co.kr/inisys/m_p_pay.php?price='+price+'&name='+name+'&o_id='+o_id);
            });
            
          });
    
        };
    
        fetchData();
        
    }else{
        alert('결제할 상품이 존재하지 않습니다.');
    }
  }


  const myDataChange = (e) => {
    const {name,value} = e.target;

    setMyData([{...myData[0],[name]:value}]);
  }
  return (
    <>
      <Container className="mb-5">
        <div className="c_pad">
          <TopTitle title="주문서 확인" />
          <div className="row p-0">
            <div className="col-6 p-0">
              <span style={{ position: 'relative',left: '-7px',cursor:'pointer' }} onClick={allChecked}><img src={check_on} style={{width:'17px',verticalAlign:'text-bottom'}}/>전체선택</span>
            </div>
            <div className="col-6 p-0 text-right">
            <span style={{cursor:'pointer',color:'#787878' }} onClick={allDelete}>전체삭제</span>
            </div>
          </div>
          <div className="row p-0">
            {
              data.map(v => <div className="col-12 pt-4 pb-3" key={v.s_id} data-id={v.s_id} style={{ position: 'relative' }}>
                {
                  v.is_check == 1
                  ? <input type="checkbox" style={{ position: 'absolute', top: '11px', left: '-5px' }} data-cart_id={v.p_cart_id} data-is_check={v.is_check} onClick={checkedData} checked/>
                  : <input type="checkbox" style={{ position: 'absolute', top: '11px', left: '-5px' }} data-cart_id={v.p_cart_id} data-is_check={v.is_check} onClick={checkedData} />
                }
               
                <div className="" data-id={v.pr_id}>
                  <div data-id={v.pr_id} style={{ ...bgSet, backgroundImage: 'url(\'' + v.pr_img + '\')' }}></div><div data-id={v.pr_id} className="w-75 d-inline-block" style={{ ...wordBreak, verticalAlign: 'top' }}>
                    <h4 className="text-primary font-weight-bold ml-3" data-id={v.pr_id} style={{ width: '160px' }}>{v.pr_name}</h4>
                    <div data-id={v.pr_id} style={{ marginTop: '15px' }}>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3"> 수량 : {v.pr_count} 개</h4>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3 text-primary">{comma(v.daeri_price * v.pr_count)} 원</h4>
                    </div>
                  </div>
                  <span data-id={v.p_cart_id} style={ab} onClick={deleteCart}><img data-id={v.p_cart_id} src={trash_img} style={traswi} /></span>
                </div>
              </div>)
            }

          </div>
          <div className="row pl-0 pr-0 pt-0 mt-5" style={{paddingBottom:'100px'}}>
                <div className="border-dark border-bottom d-block w-100">
                    <h3 className="font-weight-bold">주문자 정보</h3>
                </div>
                {
                    myData.map(v => 
                        <div className="w-100">
                            <div className="mt-4">
                                <label>시공지점</label>
                                <input name="si_name" type="text" className="" style={inputStyle} value={v.si_name} onChange={myDataChange}/>
                            </div>
                            <div className="mt-4">
                                <label>휴대폰 번호</label>
                                <input name="si_tel" type="text" className="" style={inputStyle} value={phoneFormat(v.si_tel)} onChange={myDataChange}/>
                            </div>
                            <div className="mt-4" style={{position:'relative'}}>
                                <label>주소</label>
                                <input type="text" className="" style={inputStyle} value={v.si_address} readOnly/>
                                <span className="text-primary font-weight-bold" style={abSpan} onClick={() => setIsPost(!isPost)}>검색</span>
                            </div>
                            <div className="mt-4">
                                <label>상세주소입력</label>
                                <input name="or_detail" type="text" className="" style={inputStyle} onChange={myDataChange}/>
                            </div>
                        </div>
                    )
                }

               

                <div className="col-6 text-center pl-0 mt-5" onClick={() => history.goBack()}>
                    <div className="pt-3 pb-3 btn btn-outline-secondary w-100">취소</div>
                </div>
                <div className="col-6 text-center pr-0 mt-5">
                    <div className="pt-3 pb-3 btn btn-primary w-100" onClick={goPay}>결제하기</div>
                    
                </div>
          </div>
          {
              isPost &&
              <Postcode 
              myData={myData} 
              setMyData={setMyData} 
              setIsPost={setIsPost} 
              isPost={isPost}
              />
          }
          
        </div>
        
      </Container>
      
      <Bottom_menu />

    </>

  );
}

export default OrderSheet;
